import React, { useEffect, useState } from "react";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineContent,
} from "@mui/lab";
import "./caseHighlights.css";
import {
  getRoleLabel,
  getPracticeAreaLabel,
} from "../../../helpers/stringHelper";

const CaseHighlights = ({ userId }) => {
  const [caseHighlights, setCaseHighlights] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCaseHighlights = async () => {
      try {
        const response = await fetch(
          `/api/attorney/webapp/fetchCaseHighlights?userId=${encodeURIComponent(
            userId
          )}`,
          { method: "GET" }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch case highlights");
        }

        const data = await response.json();
        setCaseHighlights(data);
      } catch (error) {
        console.error("Error fetching case highlights:", error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchCaseHighlights();
    }
  }, [userId]);

  if (loading) {
    return <div className="case-section-loading">Loading...</div>;
  }

  return (
    <div className="case-section-container">
      <div className="work-case-container">
        <p className="case-section-title">Case Highlights</p>
        <Timeline
          align="left"
          sx={{
            "& .MuiTimelineItem-root:before": {
              flex: 0,
            },
          }}
        >
          {caseHighlights && caseHighlights.length > 0 ? (
            caseHighlights.map((item) => {
              const { id, case_title, practice_area, role, year, description } =
                item;
              const dateRange = `${year}`; // Using year as the date range

              return (
                <TimelineItem key={id}>
                  <TimelineSeparator>
                    <TimelineDot color="primary" />
                    <div className="timeline-line" />
                  </TimelineSeparator>
                  <TimelineContent>
                    <div className="case-section-job-item">
                      <p className="case-section-year-range">{dateRange}</p>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          textAlign: "left",
                          marginLeft: "auto",
                          width: "60%",
                        }}
                      >
                        <p className="case-section-college">
                          {case_title} ({getPracticeAreaLabel(practice_area)})
                        </p>
                        <p className="case-section-description">
                          {description}
                        </p>
                        <p className="case-section-role">
                          {getRoleLabel(role)}
                        </p>
                      </div>
                    </div>
                  </TimelineContent>
                </TimelineItem>
              );
            })
          ) : (
            // Placeholder timeline item when no case highlights are found
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot color="grey" />
                <div className="timeline-line" />
              </TimelineSeparator>
              <TimelineContent>
                <div className="case-section-job-item">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "left",
                      marginLeft: "auto",
                      width: "60%",
                    }}
                  >
                    <p className="case-section-college">
                      No case highlights found.
                    </p>
                    <p className="case-section-description"></p>
                    <p className="case-section-role"></p>
                  </div>
                </div>
              </TimelineContent>
            </TimelineItem>
          )}
        </Timeline>
      </div>
    </div>
  );
};

export default CaseHighlights;
